import React from 'react';
import { NavDropdown } from './NavDropdown';

// Single nav link / button that conforms to the navItems contract.
// `onActivate` is fired after the user picks an item (used to close menus).
export const NavLink = ({ item, className, onActivate }) => {
  const handleClick = () => {
    item.action?.();
    onActivate?.();
  };
  if (item.children) {
    return <NavDropdown item={item} className={className} />;
  }
  if (item.type === 'scroll') {
    return (
      <button
        data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
        onClick={handleClick}
        className={className}
      >
        {item.label}
      </button>
    );
  }
  return (
    <a
      data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
      href={item.href}
      target={item.internal ? undefined : '_blank'}
      rel={item.internal ? undefined : 'noopener noreferrer'}
      onClick={onActivate}
      className={className}
    >
      {item.label}
    </a>
  );
};
